module.exports = __webpack_public_path__ + "static/img/14000043.3a3a7dab.png";